  <span id="hamburger" class="e-icons menu default" (click)="openSidebarClick()" tabindex="0" aria-label="open side bar" (keydown.enter)="openSidebarClick()" role="button"></span>
  <ejs-sidebar class="bncc-sidebar" id="default-sidebar" #customSidebar (created)="onCreated()"
               [type]="type"
               width='290px'
               [enableGestures]="false"
               [target]="target"
               [className]="'position-fixed'"
               [ngStyle]="{'top.px': defaultSideBarTop}"
  >
    <div class="title-header">
      <span id="close" class="e-icons" (click)="closeSideBarClick()" tabindex="0" role="button" aria-label="close side bar" (keydown.enter)="closeSideBarClick()"></span>
    </div>
    <div>
      <div class="" [@fadeInOut]>
        <div class="accordion-links">
          <a href='javascript:void(0)' (click)="collapseAll()" *ngIf="this.sidebarExpanded"
             tabindex="0" role="link" aria-label="collapse all sections" (keydown.enter)="collapseAll()">Collapse All Sections</a>
          <a href='javascript:void(0)' (click)="expandAll()" (keydown.enter)="expandAll()" tabindex="0" *ngIf="!this.sidebarExpanded">
            <span><i class="fas fa-arrow-down"></i></span> Expand All Sections
          </a>
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  </ejs-sidebar>
